import GiftCardIconSvg from "../../assets/card_giftcard.svg";
import { addDays } from "../../utils/date-utils";

// ---------------------------------------------------------------------------
// GiftCardIcon
// ---------------------------------------------------------------------------
const GiftCardIcon = () => (
  <img src={GiftCardIconSvg} width="20" height="20" alt="" />
);

// ---------------------------------------------------------------------------
// StatusBadge
// ---------------------------------------------------------------------------
const StatusBadge = ({ status, formattedDate, dueDate }) => {
  const isPaid = status === "Paid";
  const isDue = status === "New" || status === "Pending";

  let label = status;
  if (isPaid) {
    label = "Paid";
  } else if (isDue) {
    label = "Pending";
  }

  return (
    <div
      className={`h-[26px] px-3 rounded-full flex items-center backdrop-blur-sm flex-shrink-0 ${isPaid ? "bg-[#69D658]" : "bg-chilli"
        }`}
    >
      <span
        className={`font-headings-primary text-sm font-medium leading-5 whitespace-nowrap ${isPaid ? "text-[#000111]" : "text-white"
          }`}
      >
        {label}
      </span>
    </div>
  );
};

// ---------------------------------------------------------------------------
// RedemptionHistoryCard
// Accepts a single `row` object from the redemption history API response.
// ---------------------------------------------------------------------------
export const RedemptionHistoryCard = ({ row }) => {
  const dueDate = row.RedemptionStatusId === 3  // Paid status has RedemptionDate
    ? row.FormattedDate
    : addDays(new Date(row.RedemptionDate), 21);

  return (
    <div className="rh-card bg-background-secondary rounded-2xl px-4 py-3 flex flex-col gap-2 ring-1 ring-white/15">
      {/* Row 1: Date + Staff name  |  Status badge */}
      <div className="flex justify-between items-center gap-2">
        <div className="flex flex-col">
          <span className="text-white font-body-primary text-sm font-normal leading-6">
            {row.FormattedDate}
          </span>
          <span className="text-white font-body-primary text-xs font-normal leading-6">
            {row.UserName}
          </span>
        </div>
        <StatusBadge
          status={row.RedemptionStatusName}
          formattedDate={row.FormattedDate?.split(" ")[0]}
          dueDate={dueDate}
        />
      </div>

      {/* Row 2: Card icon + number  |  Amount */}
      <div className="flex justify-between items-center gap-2">
        <div className="flex items-center gap-2">
          <GiftCardIcon />
          <span className="text-white font-body-primary text-base font-normal leading-6">
            {row.CardNumber || row.VoucherTypeName}
          </span>
        </div>
        <span className="text-white font-headings-primary text-base font-medium leading-6 flex-shrink-0">
          {row.FormattedAmount}
        </span>
      </div>
    </div>
  );
};
